import { List as ImmutableList } from 'immutable';
import { useCallback, useMemo } from 'react';
import { isSucceeded } from '../asyncData/AsyncData';
import { useAsyncFetcher } from '../asyncData/useAsyncFetcher';
import { getDataTypeFromConfig, getCustomFilterProperties, getFilterGroupsProperties } from '../report/configReportGetters';
// @ts-expect-error Untyped import
import getProperties from '../properties';
const useFilterInvalidFilterProperties = config => {
  const dataType = useMemo(() => getDataTypeFromConfig(config), [config]);
  const filterProperties = useMemo(() => getCustomFilterProperties(config), [config]);
  const filterGroupsProperties = useMemo(() => getFilterGroupsProperties(config), [config]);
  const properties = useMemo(() => {
    return filterProperties.concat(filterGroupsProperties);
  }, [filterProperties, filterGroupsProperties]);
  const fetcher = useCallback(dataTypeParam => getProperties(dataTypeParam), []);
  const resultFormatter = useCallback(propertyMetaDataList => propertyMetaDataList.get(dataType).filter(propertyMetaData => properties.includes(propertyMetaData.get('name'))).filter(prop => !prop.get('hidden')).keySeq().toList(), [dataType, properties]);
  const propertyMetaDataReq = useAsyncFetcher({
    fetcher,
    requestArgs: dataType,
    resultFormatter
  });
  if (isSucceeded(propertyMetaDataReq)) {
    return propertyMetaDataReq.data;
  }
  return ImmutableList([]);
};
export default useFilterInvalidFilterProperties;